// src/components/UI/InputWithIcon.jsx
import React from 'react';
import {
  Flex,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  useColorMode,
} from '@chakra-ui/react';

const InputWithIcon = ({ icon, value, ...rest }) => {
  const { colorMode } = useColorMode();
  const hasValue = value && value.length > 0;

  return (
    <InputGroup>
      <Flex
        w="100%"
        align="center"
        bg="surface"
        border="1px solid"
        borderColor="borderPrimary"
        borderRadius="lg"
        transition="border-color 0.3s ease"
        _focusWithin={{
          borderColor: 'secondary',
        }}
        overflow="hidden"
      >
        <Input
          h="3rem"
          border="none"
          outline="none"
          bg="transparent"
          color="textPrimary"
          fontSize="0.9rem"
          pr="3rem" 
          _focus={{
            boxShadow: 'none',
          }}
          _placeholder={{ color: 'textSecondary' }}
          value={value}
          {...rest}
        />
        <InputRightElement pointerEvents="none" h="100%">
          <Icon as={icon} color={hasValue ? 'textPrimary' : 'textSecondary'} />
        </InputRightElement>
      </Flex>
    </InputGroup>
  );
};

export default InputWithIcon;